// extracted by mini-css-extract-plugin
module.exports = {"list":"ResultList_list__1R3QX","noItems":"ResultList_noItems__2lXfC"};